import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, PrimeTemplate } from 'primeng/api';
import { Local } from 'protractor/built/driverProviders';
import { interval } from 'rxjs';
import { BasicDataForChatRequired, ChatAppMessageProperties } from '../../Models/ChatAppProperties';
import { FlightSearchProperties } from '../../Models/FlightSearchProperties';
import { OfflineNewVersionService } from '../../Services/offline-newVersion.service';
import { OfflineActionEnum, OfflineNewVersionProperties, OfflinePassengerListProperties, OfflineSectorInformationNewVersion } from '../offlineNewProperties';
import { NavMenuComponent } from '../../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { NgClass, DatePipe } from '@angular/common';
import { ChatComponent } from '../../chat/chat.component';

@Component({
    selector: 'app-offline-booking',
    templateUrl: './offline-booking.component.html',
    styleUrls: ['./offline-booking.component.scss'],
    imports: [NavMenuComponent, Bind, Toast, ConfirmDialog, PrimeTemplate, Dialog, FormsModule, Button, NgClass, ChatComponent, DatePipe]
})
export class OfflineBookingComponent {


  constructor(private service: OfflineNewVersionService, private router: Router, private confirmationService: ConfirmationService, private messageService: MessageService) {

  }
  receivedData: ChatAppMessageProperties[] = [];
  previousStatus: number = 0;
  popupDepdetails: boolean = false;
  basicDataforChat = new BasicDataForChatRequired();
  loader: boolean = false;
  bookingId: number = 0;
  request: string = "";
  intervalId: any;
  popupPNR: boolean = false;
  popup: boolean = false;
  offlineObj = new OfflineNewVersionProperties();
  ngOnInit() {
    this.request = localStorage.getItem('RequestActionOffline');
    this.basicDataforChat.property2 = this.request;
    if (this.request == null || this.request == undefined) {
      this.basicDataforChat.property2 = "User";
      this.request = "User";
    }

    this.loader = true;
    let requestType = localStorage.getItem("RequestTypeOffline");
    if (requestType == "Create") {

      const flightSearchData = localStorage.getItem('flightSearchData');
      let searchObj = new FlightSearchProperties();
      if (!flightSearchData) {
        localStorage.setItem('OfflineArrived', 'true');
        this.loader = false;
        this.router.navigateByUrl("/offlineFlightSearch");
        return;
      }
      searchObj = JSON.parse(flightSearchData);
      this.offlineObj.adult = searchObj.adult;
      this.offlineObj.child = searchObj.child;
      this.offlineObj.infant = searchObj.infant;
      this.offlineObj.cabinClass = searchObj.cabinClass;
      this.offlineObj.isLcc = searchObj.lowCostAirline;
      this.offlineObj.isGds = searchObj.gdsAirline;
      this.offlineObj.isDirect = searchObj.nonStopFlight;
      this.offlineObj.fareType = searchObj.fareType;

      this.offlineObj.isNearByAirport = searchObj.nearByAirport;
      this.offlineObj.requestingAgency = localStorage.getItem("AgencyId");
      this.offlineObj.resquestingUser = Number(localStorage.getItem("UserId"));
      this.offlineObj.offlineRequestType = Number(localStorage.getItem("RequestTypeIdFromOffline"));
      this.offlineObj.currentBookingStatus = 1;
      let trip = "";
      if (searchObj.journeyType == 1) {
        this.offlineObj.tripType = "One Way";
        trip = "(OW)";
      }
      else if (searchObj.journeyType == 2) {
        this.offlineObj.tripType = "Return";
        trip = "(RT)";
      }
      else if (searchObj.journeyType == 3) {
        this.offlineObj.tripType = "Multicity";
        trip = "(MT)";
      }
      this.offlineObj.sector = searchObj.flightLocationInfo[0].fromCity + "--" + searchObj.flightLocationInfo[searchObj.flightLocationInfo.length - 1].toCity + " " + trip;
      this.offlineObj.prefferedAirlines = [];
      let airline = this.isValidAirline(searchObj.prefferedAirline1);
      if (airline) {
        this.offlineObj.prefferedAirlines.push(searchObj.prefferedAirline1);
      }
      let airline1 = this.isValidAirline(searchObj.prefferedAirline2);
      if (airline1) {
        this.offlineObj.prefferedAirlines.push(searchObj.prefferedAirline2);
      }
      let airline2 = this.isValidAirline(searchObj.prefferedAirline3);
      if (airline2) {
        this.offlineObj.prefferedAirlines.push(searchObj.prefferedAirline3);
      }
      this.offlineObj.sectorInfo = [];
      if (searchObj.journeyType == 2) {
        for (let i = 0; i < searchObj.flightLocationInfo.length; i++) {
          let sectorInfoobj = new OfflineSectorInformationNewVersion();
          sectorInfoobj.departureDate = searchObj.flightLocationInfo[i].departureDate;
          sectorInfoobj.fromAirport = searchObj.flightLocationInfo[i].fromAirport;
          sectorInfoobj.toAirport = searchObj.flightLocationInfo[i].toAirport;
          sectorInfoobj.fromCity = searchObj.flightLocationInfo[i].fromCity;
          sectorInfoobj.toCity = searchObj.flightLocationInfo[i].toCity;
          this.offlineObj.sectorInfo.push(sectorInfoobj);
        }
        let sectorInfoobj = new OfflineSectorInformationNewVersion();
        sectorInfoobj.departureDate = searchObj.flightLocationInfo[0].departureDate;
        sectorInfoobj.fromAirport = searchObj.flightLocationInfo[0].toAirport;
        sectorInfoobj.toAirport = searchObj.flightLocationInfo[0].fromAirport;
        sectorInfoobj.fromCity = searchObj.flightLocationInfo[0].toCity;
        sectorInfoobj.toCity = searchObj.flightLocationInfo[0].fromCity;
        sectorInfoobj.departureDate = searchObj.returnDate;
        sectorInfoobj.isReturn = true;

        this.offlineObj.sectorInfo.push(sectorInfoobj);

      }
      else {
        for (let i = 0; i < searchObj.flightLocationInfo.length; i++) {
          let sectorInfoobj = new OfflineSectorInformationNewVersion();
          sectorInfoobj.departureDate = searchObj.flightLocationInfo[i].departureDate;
          sectorInfoobj.fromAirport = searchObj.flightLocationInfo[i].fromAirport;
          sectorInfoobj.toAirport = searchObj.flightLocationInfo[i].toAirport;
          sectorInfoobj.fromCity = searchObj.flightLocationInfo[i].fromCity;
          sectorInfoobj.toCity = searchObj.flightLocationInfo[i].toCity;
          if (searchObj.journeyType == 2 && i == 1) {
            sectorInfoobj.departureDate = searchObj.returnDate;
            sectorInfoobj.isReturn = true;
          }
          this.offlineObj.sectorInfo.push(sectorInfoobj);
        }

      }

      this.CreateOfflineRequest();
    }
    else {
      this.basicDataforChat.property1 = (localStorage.getItem("offlineBookingId"));
      this.bookingId = Number(localStorage.getItem("offlineBookingId"));

      if (this.request == "Agent") {
        this.previousStatus = Number(localStorage.getItem("offlineBookingCurnStatus"));
        let offlineback = new OfflineNewVersionProperties();
        offlineback.inProgressTag = true;
        offlineback.offlineId = this.bookingId;
        offlineback.assignedUser = Number(localStorage.getItem("UserId"));;
        this.service.InProgressTag(offlineback).subscribe((data) => {
          this.loader = false;
          if (data.success) {
            this.intervalId = setInterval(() => {

              this.checkLastMessage();
            }, 300000);



            this.GetOfflineBookingById();
          }
          else {
            this.CheckROUTE();
          }
        });
      }
      else {

        this.intervalId = setInterval(() => {

          this.GetOfflineBookingById();

        }, 10000);

      }
    }
  }
  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.request == "Agent") {

      let offlineback = new OfflineNewVersionProperties();
      offlineback.inProgressTag = false;
      offlineback.offlineId = Number(localStorage.getItem("offlineBookingId"));
      offlineback.assignedUser = 0;
      this.service.InProgressTag(offlineback).subscribe((data) => {
        this.loader = false;
        if (data.success) {

        }
      });
    }
  }
  private isValidAirline = (airline: string | undefined | null): boolean => {
    return airline !== null && airline !== undefined && airline.trim() !== "";
  };
  public CreateOfflineRequest = (): void => {
    this.service.CreateOfflineRequest(this.offlineObj).subscribe((data) => {
      this.loader = false;
      if (data.success) {
        localStorage.setItem("RequestTypeOffline", "Update");
        this.basicDataforChat.property1 = data.data;
        console.log("create", this.basicDataforChat);
        this.bookingId = Number(data.data);
        localStorage.setItem("offlineBookingId", this.bookingId.toString());
        this.GetOfflineBookingById();
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.message });
      }
    });
  }
  public UpdateOfflineRequest = (status: number): void => {
    let offlineback = new OfflineNewVersionProperties();
    offlineback.assignedUser = Number(localStorage.getItem("UserId"));
    offlineback.currentBookingStatus = status;
    offlineback.pnr = this.offlineObj.pnr;
    offlineback.previousBookingStatus = this.offlineObj.currentBookingStatus;
   
    offlineback.offlineId = this.offlineObj.offlineId;
    this.service.UpdateOfflineRequest(offlineback).subscribe((data) => {
      this.loader = false;
      if (data.success) {
        this.service.GetOfflineBookingById(this.bookingId).subscribe((data) => {
          this.loader = false;
          if (data != null && data != undefined) {
            this.offlineObj = data;
            this.popupPNR = false;
            this.popup = false;
            localStorage.setItem("offlineBookingCurnStatus", this.offlineObj.currentBookingStatus.toString());
            if (this.offlineObj.currentBookingStatus == OfflineActionEnum.Booked) {

            }
            if (status == 6) {
              this.messageService.add({ severity: 'success', summary: 'Successfully', detail: "Removed From List" });

            }
            else {
              this.messageService.add({ severity: 'success', summary: 'Successfully', detail: this.offlineObj.bookingStatusName });

            }
          }
        });

      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.message });

      }
    });
  }
  handleData(data: any) {
    this.receivedData = data;

  }
  checkLastMessage() {
    //if (this.receivedData.length === 0 || this.basicDataforChat == null || this.basicDataforChat == undefined || this.basicDataforChat.property2 == null || this.basicDataforChat.property2 == undefined || this.basicDataforChat.property2 == "User") {

    //  return;
    //}
    //else if (this.request == "Agent") {
    //  const lastMessage = this.receivedData[this.receivedData.length - 1];
    //  if (lastMessage.creationDate == null) {
    //    return;
    //  }
    //  const lastMessageDate = new Date(lastMessage.creationDate);
    //  const currentDate = new Date();
    //  const timeDifference = currentDate.getTime() - lastMessageDate.getTime(); // in milliseconds
    //  const minutesDifference = timeDifference / (1000 * 60);
    //  if (minutesDifference > 5) {
    //    let offlineback = new OfflineNewVersionProperties();
    //    offlineback.inProgressTag = false;
    //    offlineback.offlineId = this.offlineObj.offlineId;
    //    offlineback.assignedUser = 0;
    //    this.service.InProgressTag(offlineback).subscribe((data) => {
    //      this.loader = false;
    //      if (data.success) {
    //        this.CheckROUTE();
    //      }
    //    });


    //  } else {
    //    console.log('Less than 5 minutes have passed. Staying on the current route.');
    //  }
    //}

    if (this.request == "Agent") {
      if (this.offlineObj.lastActivityTime == null) {
        return;
      }
      const lastMessageDate = new Date(this.offlineObj.lastActivityTime);
      const currentDate = new Date();
      const timeDifference = currentDate.getTime() - lastMessageDate.getTime(); // in milliseconds
      const minutesDifference = timeDifference / (1000 * 60);
      if (minutesDifference > 5) {
        this.confirmationService.confirm({
          header: 'Confirmation',
          message: 'You are working on this request?',
          acceptIcon: 'pi pi-check mr-2',
          rejectIcon: 'pi pi-times mr-2',
          rejectButtonStyleClass: 'p-button-sm',
          acceptButtonStyleClass: 'p-button-outlined p-button-sm',
          accept: () => {
            clearTimeout(timeoutHandler);
            let offlineback = new OfflineNewVersionProperties();
            offlineback.inProgressTag = true;
            offlineback.offlineId = this.bookingId;
            offlineback.assignedUser = Number(localStorage.getItem("UserId"));;
            this.service.InProgressTag(offlineback).subscribe((data) => {
              this.loader = false;
              if (data.success) {

              }
            });
          },
          reject: () => {
            clearTimeout(timeoutHandler);
            let offlineback = new OfflineNewVersionProperties();
            offlineback.inProgressTag = false;
            offlineback.offlineId = this.offlineObj.offlineId;
            offlineback.assignedUser = 0;
            this.service.InProgressTag(offlineback).subscribe((data) => {
              this.loader = false;
              if (data.success) {
                this.CheckROUTE();
              }
            });
          }
        });


        const timeoutHandler = setTimeout(() => {
          this.CheckROUTE();
        }, 60000);


      }
      else {
      }
    }
  }
  CheckROUTE() {
    let fromroute = localStorage.getItem('fromOfflineRequestRoute');
    if (fromroute == "managerOfflineRequestList") {

      this.router.navigateByUrl("/managerOfflineRequestList");
    }
    else  {
      this.router.navigateByUrl("/offlineRequestList");
    }
    
  }
  GetOfflineBookingById() {
    this.service.GetOfflineBookingById(this.bookingId).subscribe((data) => {
      this.loader = false;
      if (data != null && data != undefined) {
        let userid = Number(localStorage.getItem("UserId"));
        this.offlineObj = data;

        if (userid == this.offlineObj.assignedUser) {
          if ((this.previousStatus == this.offlineObj.currentBookingStatus) && this.offlineObj.inProgressTag) {
            this.offlineObj.bookingStatusName = "In Process";
          }
        }
        else if (this.request == "Agent") {
          this.CheckROUTE();
        }

      }
    });
  }
  viewflight() {
    this.popupDepdetails = true;
  }


  showPopupTicketPassenger() {
    if (this.offlineObj.passengerList == null || this.offlineObj.passengerList.length == undefined || this.offlineObj.passengerList.length == 0 ) {
      this.offlineObj.passengerList = [];
      let obj = new OfflinePassengerListProperties();
      this.offlineObj.passengerList.push(obj);

    }
    this.popup = true;
   
  }
  showPopupPNR() {
    this.popupPNR = true;
  }
  addNewPassenger() {
    let obj = new OfflinePassengerListProperties();
    this.offlineObj.passengerList.push(obj);
  }
  removePassenger(index: number) {
    if (this.offlineObj.passengerList[index].passengerId > 0) {
      this.offlineObj.passengerList[index].isDeleted = true;
    }
    else {
      this.offlineObj.passengerList.splice(index);

    }
  }
  passengerTypes = [
    { label: 'Select', value: '' },
    { label: 'Adult', value: 'Adult' },
    { label: 'Child', value: 'Child' },
    { label: 'Infant', value: 'Infant' }
  ];
  UpdateOfflineTicketRequest() {
    let offlineback = new OfflineNewVersionProperties();
    offlineback.assignedUser = Number(localStorage.getItem("UserId"));
    offlineback.currentBookingStatus = OfflineActionEnum.Ticketed;
    offlineback.previousBookingStatus = this.offlineObj.currentBookingStatus;
    offlineback.offlineId = this.offlineObj.offlineId;
    offlineback.passengerList = this.offlineObj.passengerList;
    offlineback.pnr = this.offlineObj.pnr;
    this.service.UpdateOfflineRequest(offlineback).subscribe((data) => {
      this.loader = false;
      if (data.success) {
        this.service.GetOfflineBookingById(this.bookingId).subscribe((data) => {
          this.loader = false;
          if (data != null && data != undefined) {
            this.offlineObj = data;
            this.popupPNR = false;
            this.popup = false;
            localStorage.setItem("offlineBookingCurnStatus", this.offlineObj.currentBookingStatus.toString());
            
            
              this.messageService.add({ severity: 'success', summary: 'Successfully', detail: this.offlineObj.bookingStatusName });

           
          }
        });

      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.message });

      }
    });
  }
}
